import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button, Form, Icon, InputNumber, Input, Popconfirm } from 'antd'
import { infoRequired, validatePassword } from '../../../utils/validators'
import { gerarResgate } from '../../../redux-flow/actions/contratos'
import moment from 'moment'


class FormResgate extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            valorInput: 0,
            disabled: false,
            showButton: false
        }
    }

    changeInput = e => {
        this.setState({
            valorInput: e
        })
    }

    refreshPage() {
        setTimeout(function(){
            window.location.reload()
        }, 5000)
    }

    handleClick(e) {
        e.preventDefault()
        if (this.state.disabled) {
            return
        }
        this.setState({ disabled: true }) 
    }

    render() {
        const { form, handleSubmit, idContrato, tipo, logMessage, isLoading, userId } = this.props
        let success =  this.props.success

        return success ? (
            <div className="finishedSignup" onLoad={this.refreshPage()}>
                <div>
                    <h2 className="text-dark">Resgate requisitado!</h2>
                    <p className="text-dark">
                        Sucesso! Seu resgate foi requisitado e está sendo processado! <br />
                    </p>
                </div>
            </div>
        ) : (
            <Form className="formContrato" layout="vertical" onSubmit={handleSubmit(form, idContrato, tipo, userId)}>
                {logMessage && <Form.Item>
                    <div class="alert alert-danger fade show notificacao-status">
                        <p className="mb-0">{logMessage}</p>
                    </div>
                </Form.Item>}
                <div style={{ textAlign: 'center' }}>
                    {isLoading && <Form.Item>
                        <Icon type="loading" />
                    </Form.Item>}
                </div>
                <Form.Item label="Valor">
                <div className='d-flex align-items-center justify-content-center'>
                    <h6 className="mb-0 mt-1">R$</h6>
                    {form.getFieldDecorator('valor', {
                        initialValue: 20,
                        rules: [ infoRequired ]
                    })(
                        <InputNumber
                            className="ml-2"
                            style={{ width: '100%' }}
                            min={20}
                            precision={2}
                            step={0.01}
                            onChange={e => this.changeInput(e)}
                        />
                    )}
                </div>
                </Form.Item>
                <Form.Item>
                    {!isLoading ?
                    <Button disabled={isLoading} className="btnGrafico" htmlType="submit" style={{ width: '100%' }}>
                        Enviar
                    </Button> :
                    <Button className="btnGraficoDisabled" style={{ width: '100%' }}>Enviando...</Button>}
                </Form.Item>                    
            </Form>
        )
    }
}

const mapStateToProps = state => ({
    logMessage: state.contratos.message,
    isLoading: state.contratos.isLoading,
    success: state.contratos.success,
    userid: state.login.userid
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, idContrato, tipo, userId) => e => {
        e.preventDefault()
        dispatch(gerarResgate(form, idContrato, tipo, userId))
    }
})

export default Form.create({ name: 'create-resgate' })(
    connect(mapStateToProps, mapDispatchToProps)(FormResgate)
)